package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordType
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordPatientSex
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordPersonType
import kotlin.collections.Set
import com.jingfangpai.common.data.type.DateTime
import com.jingfangpai.common.data.serializer.DateTimeSerializer
import com.jingfangpai.common.orm.mapping.enums.MedicalRecordStatus

@Serializable
open class MedicalRecord(var id: String? = null){
	var title: String? = null
	var type: MedicalRecordType? = null
	var source: String? = null
	var bookId: String? = null
	var patientId: String? = null
	var patientName: String? = null
	var patientSex: MedicalRecordPatientSex? = null
	var patientAge: Int? = null
	var personType: Set<MedicalRecordPersonType>? = null
	var lastRecodeId: String? = null
	var doctorId: String? = null
	var doctorName: String? = null
	var description: String? = null
	var prescriptionContent: String? = null
	var prescriptionId: String? = null
	@Serializable(with = DateTimeSerializer::class)
	var createdOn: DateTime? = null
	var createdBy: String? = null
	var status: MedicalRecordStatus? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as MedicalRecord
		if (id != other.id) return false
		if (title != other.title) return false
		if (type != other.type) return false
		if (source != other.source) return false
		if (bookId != other.bookId) return false
		if (patientId != other.patientId) return false
		if (patientName != other.patientName) return false
		if (patientSex != other.patientSex) return false
		if (patientAge != other.patientAge) return false
		if (personType != other.personType) return false
		if (lastRecodeId != other.lastRecodeId) return false
		if (doctorId != other.doctorId) return false
		if (doctorName != other.doctorName) return false
		if (description != other.description) return false
		if (prescriptionContent != other.prescriptionContent) return false
		if (prescriptionId != other.prescriptionId) return false
		if (createdOn != other.createdOn) return false
		if (createdBy != other.createdBy) return false
		if (status != other.status) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (title?.hashCode() ?: 0)
		result = 31 * result + (type?.hashCode() ?: 0)
		result = 31 * result + (source?.hashCode() ?: 0)
		result = 31 * result + (bookId?.hashCode() ?: 0)
		result = 31 * result + (patientId?.hashCode() ?: 0)
		result = 31 * result + (patientName?.hashCode() ?: 0)
		result = 31 * result + (patientSex?.hashCode() ?: 0)
		result = 31 * result + (patientAge?.hashCode() ?: 0)
		result = 31 * result + (personType?.hashCode() ?: 0)
		result = 31 * result + (lastRecodeId?.hashCode() ?: 0)
		result = 31 * result + (doctorId?.hashCode() ?: 0)
		result = 31 * result + (doctorName?.hashCode() ?: 0)
		result = 31 * result + (description?.hashCode() ?: 0)
		result = 31 * result + (prescriptionContent?.hashCode() ?: 0)
		result = 31 * result + (prescriptionId?.hashCode() ?: 0)
		result = 31 * result + (createdOn?.hashCode() ?: 0)
		result = 31 * result + (createdBy?.hashCode() ?: 0)
		result = 31 * result + (status?.hashCode() ?: 0)
		return result
	}

}
